export function MetricCard({
  title,
  value,
  max,
  suffix = '',
}: {
  title: string;
  value: number | string;
  max?: number;
  suffix?: string;
}) {
  const isNumeric = typeof value === 'number';
  const radius = 42;
  const stroke = 6;
  const normalizedRadius = radius - stroke;
  const circumference = normalizedRadius * 2 * Math.PI;
  const percentage =
    isNumeric && max != null && max > 0 ? Math.min(value / max, 1) : 1;
  const strokeDashoffset = circumference * (1 - percentage);

  return (
    <div className="bg-white rounded-lg shadow p-4 flex flex-col items-center">
      <p className="text-sm text-gray-500 mb-2 text-center">{title}</p>

      <div className="relative w-20 h-20">
        <svg height="80" width="80">
          <circle
            stroke="#e5e7eb"
            fill="transparent"
            strokeWidth={stroke}
            r={normalizedRadius}
            cx="40"
            cy="40"
          />
          <circle
            stroke={isNumeric ? '#22c55e' : '#e5e7eb'}
            fill="transparent"
            strokeWidth={stroke}
            strokeDasharray={`${circumference} ${circumference}`}
            strokeDashoffset={strokeDashoffset}
            strokeLinecap="round"
            r={normalizedRadius}
            cx="40"
            cy="40"
            transform="rotate(-90 40 40)"
          />
        </svg>

        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-sm font-bold text-gray-900 text-center">
            {value}
            {suffix}
          </span>
        </div>
      </div>
    </div>
  );
}
